var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableColumnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95415 2.09182C5.37655 2.09182 4.9083 1.62358 4.9083 1.04597C4.9083 0.468364 5.37655 0.00012207 5.95415 0.00012207C6.53176 0.00012207 7 0.468364 7 1.04597C7 1.62358 6.53176 2.09182 5.95415 2.09182Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95415 6.04584C5.37655 6.04584 4.9083 5.5776 4.9083 5C4.9083 4.42239 5.37655 3.95415 5.95415 3.95415C6.53176 3.95415 7 4.42239 7 5C7 5.5776 6.53176 6.04584 5.95415 6.04584Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95415 9.99987C5.37655 9.99987 4.9083 9.53163 4.9083 8.95402C4.9083 8.37641 5.37655 7.90817 5.95415 7.90817C6.53176 7.90817 7 8.37641 7 8.95402C7 9.53163 6.53176 9.99987 5.95415 9.99987Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68389 2.09182C1.10628 2.09182 0.638041 1.62358 0.638041 1.04597C0.638041 0.468364 1.10628 0.00012207 1.68389 0.00012207C2.26149 0.00012207 2.72974 0.468364 2.72974 1.04597C2.72974 1.62358 2.26149 2.09182 1.68389 2.09182Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68389 6.04584C1.10628 6.04584 0.638041 5.5776 0.638041 5C0.638041 4.42239 1.10628 3.95415 1.68389 3.95415C2.26149 3.95415 2.72974 4.42239 2.72974 5C2.72974 5.5776 2.26149 6.04584 1.68389 6.04584Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68389 9.99987C1.10628 9.99987 0.638041 9.53163 0.638041 8.95402C0.638041 8.37641 1.10628 7.90817 1.68389 7.90817C2.26149 7.90817 2.72974 8.37641 2.72974 8.95402C2.72974 9.53163 2.26149 9.99987 1.68389 9.99987Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableColumnIcon);
export default __webpack_public_path__ + "static/media/table-column-icon.09b60ccc83054502dac40bf8a9f1676c.svg";
export { ForwardRef as ReactComponent };